import React, { Component } from 'react';
import { connect } from 'react-redux';
import {List} from "immutable";
import {isFloat} from 'validator';

// Actions
import {updateStock} from "../../actions/stock";

class AdjustStockDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            real_amount: this.props.stock.get('real_amount'),
            security_stock: this.props.stock.get('security_stock')
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.onCreateClick !== prevProps.onCreateClick && this.props.onCreateClick) {
            this.props.updateStock(this.props.stock.get('_id'), {
                ...(this.state.real_amount !== this.props.stock.get('real_amount')) ? { real_amount: this.state.real_amount } : '',
                ...(this.state.security_stock !== this.props.stock.get('security_stock')) ? { security_stock: this.state.security_stock } : '',
            }, {
                projection: 'product warehouse real_amount available_amount total_amount security_stock',
                populateRefs: [{
                    field: 'product',
                    projection: 'name'
                }, {
                    field: 'warehouse',
                    projection: 'name'
                }]
            });
            this.props.onCloseModal();
        }
    }

    validateStock = () => {
        if (
            this.state.real_amount !== '' &&
            this.state.security_stock !== ''
        ) {
            this.props.onCanSubmit(true);
        } else {
            this.props.onCanSubmit(false);
        }
    };

    render() {
        const { real_amount, security_stock } = this.state;
        const { stock, warehouseName } = this.props;

        return (
            <div>
                <h4 style={{ color: 'black' }} >Almacén</h4>
                <div className="row modal-row">
                    <div className="col">
                        <span style={{ fontSize: '0.9rem' }} >{ warehouseName }</span>
                    </div>
                </div>
                <h4 style={{ color: 'black' }} >Producto</h4>
                <div className="row modal-row">
                    <div className="col">
                        <span style={{ fontSize: '0.9rem' }} >{ stock.get('product') }</span>
                    </div>
                </div>
                <h4 style={{ color: 'black' }} >Stock real</h4>
                <div className="row modal-row">
                    <div className="col-4">
                        <input
                            className="form-control"
                            type="text"
                            value={real_amount}
                            onChange={ (event) => {
                                let real_amount = event.target.value;
                                if (real_amount === '') real_amount = '0';
                                if (isFloat(real_amount)) {
                                    this.setState({ real_amount}, this.validateStock);
                                }
                            }}
                        />
                    </div>
                </div>
                <h4 style={{ color: 'black' }} >Stock de seguridad</h4>
                <div className="row modal-row">
                    <div className="col-4">
                        <input
                            className="form-control"
                            type="text"
                            value={security_stock}
                            onChange={ (event) => {
                                let security_stock = event.target.value;
                                if (security_stock === '') security_stock = '0';
                                if (isFloat(security_stock)) {
                                    this.setState({ security_stock}, this.validateStock);
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const productsReducer = state.products;

    // Products
    const products = productsReducer.get('payload') || List([]);

    return {
        products
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateStock: (stockId, stock, options) => dispatch(updateStock(stockId, stock, options))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdjustStockDialog);


// WEBPACK FOOTER //
// ./src/components/dialogs/AdjustStockDialog.js